export default __webpack_public_path__ + "static/media/werking-dashboard-1.01d8307a.JPG";